import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#4B7EFF" rx={5} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m6 7 3.868 18h3.579L16 10.856 18.553 25h3.579L26 7.15h-3.208l-2.5 13.862L17.656 7h-3.312l-2.636 14.012L9.208 7z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWord;
